export default __webpack_public_path__ + "static/media/Dia-internacional-das-Mulheres8M-1.6a03ccdc.jpg";